// export const BASE_URL =
//   process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_BASE_URL
//     : process.env.REACT_APP_BASE_PROD_URL;

export const BASE_URL = "https://apibackoffice.financeseva.com";
